module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_hotel-4c76e76399d0196f0977088f792d99bf.png";